// extracted by mini-css-extract-plugin
export default {"ldsRing":"circular-loader_ldsRing__0OHea"};